import React, { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { parseJwt } from '../../views/login/Login';
import './ProfileSettingsLayout.scss';

const navigationLinks = [
	{
		path: 'profile',
		text: 'Your profile',
	},
	// {
	// 	path: 'notifications',
	// 	text: 'Notifications',
	// },
	{
		path: 'business-settings',
		text: 'Business settings ',
	}
];

export const GetUserInformation = (): any => {
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const user = parseJwt(authUser.idToken);
	return user;
};

export const ProfileSettingsLayout: FC = () => {
	const { pathname } = useLocation();
	const segments = pathname.split('/');
	const activeSection = segments[segments.length - 1];
	const user = GetUserInformation();
	const userGroups = user?.['cognito:groups'];
	// const isBusinessSettingsTab = pathname === `${url}/business-settings`;
	//
	// const progress = 25;

	return (
		<div className="card mb-5">
			<div className="card-body border-bottom pb-8">
				<div className="d-flex align-items-center justify-content-between">
					<div className="d-flex align-items-center">
						<div className="d-flex align-items-center justify-content-center text-danger fw-bolder bg-light-danger rounded-2 fs-1 px-13 py-10">
							<span>{user?.given_name?.[0] || ''}</span>
							<span>{user?.family_name?.[0] || ''}</span>
						</div>
						<div className="fs-2 fw-bolder ms-13">
							<span>{user?.given_name || ''}{' '}</span>
							<span>{user?.family_name || ''}</span>
							<div className="fs-7 text-muted">{userGroups.join(', ')}</div>
						</div>
					</div>
					{/*{*/}
					{/*	isBusinessSettingsTab && (*/}
					{/*		<>*/}
					{/*			<div className="title-width">*/}
					{/*				<Title title="Complete your account" additionalClass="fw-bolder fs-4 mb-3"/>*/}
					{/*				<div className="text-muted fs-9">*/}
					{/*					Your account is now active, in order to use FlexCharge successfully you need to:*/}
					{/*				</div>*/}
					{/*			</div>*/}
					{/*			<ul className="mb-0">*/}
					{/*				<li className="fw-bolder">Add your <span className="text-primary">company’s logo</span></li>*/}
					{/*				<li className="fw-bolder">Fill in your <span className="text-primary">Customer Support Contact</span></li>*/}
					{/*				<li className="fw-bolder">Invite your <span className="text-primary">team’s Developer</span></li>*/}
					{/*				<li className="fw-bolder">Set-up 2-Factor-Authentication <span className="text-primary">(2FA)</span></li>*/}
					{/*			</ul>*/}
					{/*			<div className="col-3">*/}
					{/*				<div className="d-flex align-items-center justify-content-between">*/}
					{/*					<Title title="Completed" additionalClass="text-muted"/>*/}
					{/*					<div className="fs-2 fw-bolder">{progress} %</div>*/}

					{/*				</div>*/}
					{/*				<progress*/}
					{/*					max="100"*/}
					{/*					value={progress}*/}
					{/*					className="red"*/}
					{/*				/>*/}
					{/*			</div>*/}
					{/*		</>*/}
					{/*	)*/}
					{/*}*/}
				</div>
			</div>

			<div className="d-flex align-items-center merchant-navigation px-9">
				{
					navigationLinks?.map(({ path, text }) => (
						<Link
							key={path}
							to={`/user-settings/${path}`}
							className={clsx(
								'd-flex align-items-center justify-content-center fs-8 fs-sm-7 fw-bolder text-center px-3 h-50px tab-style',
								activeSection === path ? 'text-danger tab-bgc' : 'text-dark')
							}
						>
							{text}
						</Link>
					))
				}
			</div>
		</div>
	);
};
